export const customerAppTheme = {
	SBG: "SBG",
}
export const customerAppColor = {
	SBG: "#015093",
}
